import _ from 'lodash';
import globalStore from '$$globalStore';
import constants from '$$helpers/constants';
import projectsModel from '$$projectModel';

export default function (task) {
  let total = 0;
  const projectAutoBudget = projectsModel.getProjectAutoBudget(task.gantt_id);

  if (projectAutoBudget) {
    _.each(task.resources, function (resource) {
      const resourceSettingsOnProject = globalStore.getters['resourcesModel/getResourceProjectSettings'](resource.resource_id, task.gantt_id);

      if (!resourceSettingsOnProject) {
        return;
      }

      if (resourceSettingsOnProject.type === constants.RESOURCE_COST_TYPE) {
        total += resource.value;
        return;
      }

      total += resource.value * resourceSettingsOnProject.cost;

    });
  } else {
    total += task.total_price || 0;
  }

  total = Math.round(total * 100) / 100;

  return total;
}
